<div class="modal active procSemiWid">
  <div class="modal__container modal__container--sm" style="height: fit-content;top: 10%;max-height: none;">
    <div class="fields">
      <h2 class="title">Procedure Semi-Widths</h2>
      <div class="close" (click)="cancelConfiguration()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngProcedureForm" [formGroup]="form" id="procedureForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>B-RNAV / RNAV-5 Parameters</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">B-RNAV EN-ROUTE</label>
                  <input
                    maxlength="8"
                    [(ngModel)]="configurationController.currentConfiguration.configurationProcedure.bRnavEnRoute"
                    formControlName="BRNavEnRoute"
                    type="number"
                    name="BRNavEnRoute"
                    id="BRNavEnRoute"
                    required
                    disabled
                  />
                  <span span style="width:'5%'">[NM]</span>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>P-RNAV / RNAV-1 Parameters</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">P-RNAV in TMA</label>
                  <input
                    maxlength="8"
                    [(ngModel)]="configurationController.currentConfiguration.configurationProcedure.pRnavTma"
                    formControlName="pRnavTma"
                    type="number"
                    name="pRnavTma"
                    id="pRnavTma"
                    required
                    disabled
                  />
                  <span span style="width:'5%'">[NM]</span>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">P-RNAV EN-ROUTE</label>
                  <input
                    maxlength="8"
                    [(ngModel)]="configurationController.currentConfiguration.configurationProcedure.pRnavEnRoute"
                    formControlName="pRnavEnRoute"
                    type="number"
                    name="pRnavEnRoute"
                    id="pRnavEnRoute"
                    required
                    disabled
                  />
                  <span span style="width:'5%'">[NM]</span>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>A-RNP Parameters</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">A-RNP in TMA</label>
                  <input
                    maxlength="8"
                    [(ngModel)]="configurationController.currentConfiguration.configurationProcedure.aRnpTma"
                    formControlName="aRnpTma"
                    type="number"
                    name="aRnpTma"
                    id="aRnpTma"
                    required
                    disabled
                  />
                  <span span style="width:'5%'">[NM]</span>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">A-RNP EN-ROUTE</label>
                  <input
                    maxlength="8"
                    [(ngModel)]="configurationController.currentConfiguration.configurationProcedure.aRnpEnRoute"
                    formControlName="aRnpEnRoute"
                    type="number"
                    name="aRnpEnRoute"
                    id="aRnpEnRoute"
                    required
                    disabled
                  />
                  <span span style="width:'5%'">[NM]</span>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>TMA / EN-ROUTE Boundary Parameters</h4>
                <span> </span>
              </div>
                <div class="input-fields">
                  <div>
                    <label for="">Distance from ARP</label>
                    <input
                      maxlength="8"
                      [(ngModel)]="configurationController.currentConfiguration.configurationProcedure.distanceFromArpNM"
                      (change)='updateDistanceFromArpValue("m",$event.target.value)'
                      formControlName="distanceFromArpNM"
                      type="number"
                      name="distanceFromArpNM"
                      id="distanceFromArpNM"
                      class="defaultAltitudesInput"
                      required
                      disabled
                    />
                    <span span style="width:'5%'">[NM]</span>
                    <input
                      maxlength="10"
                      [(ngModel)]="configurationController.currentConfiguration.configurationProcedure.distanceFromArpM"
                      (change)='updateDistanceFromArpValue("nm",$event.target.value)'
                      formControlName="distanceFromArpM"
                      type="number"
                      name="distanceFromArpM"
                      id="distanceFromArpM"
                      class="defaultAltitudesInput"
                      required
                      disabled
                    />
                    <span span style="width:'5%'">[m]</span>
                  </div>
                </div>
                <div class="input-fields">
                  <div>
                    <label for="">Altitude (AMSL)</label>
                    <input
                      maxlength="10"
                      [(ngModel)]="configurationController.currentConfiguration.configurationProcedure.altitudeFt"
                      (change)='updateAltitudeValue("m",$event.target.value)'
                      formControlName="altitudeFt"
                      type="number"
                      name="altitudeFt"
                      id="altitudeFt"
                      class="defaultAltitudesInput"
                      required
                      disabled
                    />
                    <span span style="width:'5%'">[ft]</span>
                    <input
                      maxlength="10"
                      [(ngModel)]="configurationController.currentConfiguration.configurationProcedure.altitudeM"
                      (change)='updateAltitudeValue("ft",$event.target.value)'
                      formControlName="altitudeM"
                      type="number"
                      name="altitudeM"
                      id="altitudeM"
                      class="defaultAltitudesInput"
                      required
                      disabled
                    />
                    <span span style="width:'5%'">[m]</span>
                  </div>
                </div>
              </div>
              <div class="fields__block__section">
                <div class="title">
                  <h4>Procedure Interpolation Steps</h4>
                  <span> </span>
                </div>
                  <div class="input-fields">
                    <div>
                      <label for="">Procedure Alongtrack</label>
                      <input
                        maxlength="8"
                        [(ngModel)]="configurationController.currentConfiguration.configurationProcedure.procedureAlongtrackNM"
                        (input)='updateProcedureAlongtrackValue("m",$event.target.value)'
                        formControlName="procedureAlongTrackNM"
                        type="number"
                        name="procedureAlongtrackNM"
                        id="procedureAlongtrackNM"
                        class="defaultAltitudesInput"
                        required
                      />
                      <span span style="width:'5%'">[NM]</span>
                      <input
                        maxlength="10"
                        [(ngModel)]="configurationController.currentConfiguration.configurationProcedure.procedureAlongtrackM"
                        (input)='updateProcedureAlongtrackValue("nm",$event.target.value)'
                        formControlName="procedureAlongTrackM"
                        type="number"
                        name="procedureAlongTrackM"
                        id="procedureAlongtrackM"
                        class="defaultAltitudesInput"
                        required
                      />
                      <span span style="width:'5%'">[m]</span>
                      <span class="error" *ngIf="form.get('procedureAlongTrackM').errors">
                        The Procedure Width value shouwld be between 0.1 and 5 ft or 185 and 9260 m.
                       </span>
                    </div>
                  </div>
                  <div class="input-fields">
                    <div>
                      <label for="">Procedure Width</label>
                      <input
                        maxlength="10"
                        [(ngModel)]="configurationController.currentConfiguration.configurationProcedure.procedureWidthNM"
                        (input)='updateProcedureWidthValue("m",$event.target.value)'
                        formControlName="procedureWidthNM"
                        type="number"
                        name="procedureWidthNM"
                        id="procedureWidthNM"
                        class="defaultAltitudesInput"
                        required
                      />
                      <span span style="width:'5%'">[NM]</span>
                      <input
                        maxlength="10"
                        [(ngModel)]="configurationController.currentConfiguration.configurationProcedure.procedureWidthM"
                        (input)='updateProcedureWidthValue("nm",$event.target.value)'
                        formControlName="procedureWidthM"
                        type="number"
                        name="procedureWidthM"
                        id="procedureWidthM"
                        class="defaultAltitudesInput"
                        required
                      />
                      <span span style="width:'5%'">[m]</span>
                      <span class="error" *ngIf="form.get('procedureWidthM').errors">
                        The Procedure Width value shouwld be between 0.1 and 5 ft or 185 and 9260 m.
                       </span>
                    </div>
                  </div>
                </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="form.valid ? 'blue' : 'gray'" (click)="saveConfiguration()" [disabled]="!form.valid">
              Save
            </button>
            <button type="submit" [ngClass]="form.valid ? 'blue' : 'gray'" (click)="retoreDefaults();">
              Restore Defaults
            </button>
            <button class="gray" (click)="cancelConfiguration()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
